module.exports = __webpack_public_path__ + "img/history_detail_icon_tried.240e0959.png";